module.exports = __webpack_public_path__ + "img/phone-screen-erik-2.943d1976.jpg";